import { LOCALE } from "core/interfaces";

import { extractTranslation } from "~/common/helpers/extract-translation";
import type { Color, ColorAdapted } from "~/common/interfaces/entities/color.interface";

export const colorDenormalize = (colorAdapted: ColorAdapted): Color => {
	const { name: _name, ...rest } = colorAdapted;

	return {
		...rest
	};
};

export const colorNormalize = (locale: Ref<LOCALE>, color: Color): ColorAdapted => {
	const { translations, ...rest } = color;

	const translation = translations && extractTranslation(locale.value, translations);

	return {
		name: translation ? translation.name : "NAME",
		translations,
		...rest
	};
};
